import { useEffect, useCallback, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import moment from 'moment-timezone'

import CommonPage from 'app/common/templates/CommonPage'
import PlainDateMonthSwitcher from 'app/common/ui-next/plain-date-month-picker'
import DateSwitcher from 'app/common/ui/DateSwitcher'
import { fetchBalance } from 'app/actions/cafeteria/balance'
import {
  useAcquiringSettingsFetch,
  useAcquiringSettingsAvailability,
} from 'app/dataProviders/acquiring/settings/hooks'
import { useTransferAvailability, useTransferFetch } from 'app/dataProviders/transfer/hooks'
import Sticky from 'app/common/templates-next/sticky'

import Navigation from './Navigation'
import styles from './FinancesPage.scss'

type Props = {
  children: ReactNode
  params: {
    date: string
    type: string
  }
  location: {
    pathname: string
  }
  router: {
    push: (path: string) => void
  }
}

const FinancesPage = ({ children, params: { date, type }, router: { push } }: Props) => {
  const dispatch = useDispatch()
  const { t } = useTranslation('finances')
  const currentStudentId = useSelector((state: any) => state.settings.current.id, shallowEqual) || 0
  const baseUrl = 'finances/my'

  useEffect(() => {
    // чтоб получить allowed
    dispatch(fetchBalance())
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeDate = useCallback(
    (d, f) => {
      push(`${baseUrl}/${moment(d, f).format('YYYY-MM')}`)
    },
    [baseUrl, push],
  )

  useAcquiringSettingsFetch()
  const showRefill = useAcquiringSettingsAvailability()

  useTransferFetch()
  const showTransfer = useTransferAvailability()

  return (
    <CommonPage header={t('header')}>
      <Sticky>
        {(ref, _, shadow) => (
          <Navigation
            ref={ref}
            currentStudentId={currentStudentId}
            onRedirect={push}
            showRefill={showRefill}
            showTransfer={showTransfer}
            className={styles.menu}
            shadow={shadow}
          >
            {!type && (
              <>
                <DateSwitcher
                  current={date}
                  baseUrl={baseUrl}
                  month
                  format="MMMM"
                  className={styles.dateSwitcher}
                />
                <div className={styles.datePickerContainer}>
                  <PlainDateMonthSwitcher
                    date={date}
                    dateFormat="YYYY-MM"
                    onChangeDate={handleChangeDate}
                    monthsAmount={24}
                    hideDateMonthSwitcher
                  />
                </div>
              </>
            )}
          </Navigation>
        )}
      </Sticky>
      {children}
    </CommonPage>
  )
}

export default FinancesPage
